export class PushNotificationRequestModel {
    constructor (
        public deviceID?: string,
        public deviceFCMToken?: string,
    ) {}
}